import { render } from "./PortfolioAnchorPoint.vue?vue&type=template&id=6aa4e9f1"
import script from "./PortfolioAnchorPoint.vue?vue&type=script&lang=js"
export * from "./PortfolioAnchorPoint.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Kyler\\OneDrive\\Website\\website2022\\development\\kylerherrera-2022\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__